import { getCookie, setCookie, deleteCookie } from 'cookies-next/client';
import { AllowedCookies, defaultCookies } from './allowedCookies';
import dayjs from 'dayjs';

type IState = AllowedCookies;

export class CookieStorageClient {
  get<T extends keyof IState>(key: T): IState[T] {
    const stringifyValue = getCookie(key);
    try {
      return stringifyValue ? JSON.parse(stringifyValue) : defaultCookies[key];
    } catch {
      return (stringifyValue as IState[T]) || defaultCookies[key];
    }
  }
  set<T extends keyof IState>(key: T, value: IState[T], exp?: number): boolean {
    try {
      setCookie(key, JSON.stringify(value), {
        expires: exp ? dayjs().add(exp, 'days').toDate() : undefined,
      });
      return true;
    } catch {
      return false;
    }
  }

  delete<T extends keyof IState>(key: T) {
    try {
      deleteCookie(key);
    } catch {
      /* empty */
    }
  }
}

export const ccStorage = new CookieStorageClient();
